<template>
  <b-form class="av-tooltip tooltip-label-bottom">
    <b-row>
      <b-col>
        <template v-if="isFindId">
          <b-form-group :label="$t('user.fullname')" class="has-float-label mb-4">
            <b-form-input type="text" v-model="$v.data.fullName.$model" :state="!$v.data.fullName.$error"/>
            <b-form-invalid-feedback v-if="!$v.data.fullName.required">{{$t('user.required-name')}}
            </b-form-invalid-feedback>
          </b-form-group>
        </template>
        <template v-else>
          <b-form-group :label="$t('user.username')" class="has-float-label mb-4">
            <b-form-input type="text" v-model="$v.data.username.$model" :state="!$v.data.username.$error"/>
            <b-form-invalid-feedback v-if="!$v.data.username.required">{{$t('user.required-id')}}
            </b-form-invalid-feedback>
          </b-form-group>
        </template>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group :label="$t('user.email')" class="has-float-label mb-4">
          <b-form-input type="text" v-model="$v.data.email.$model" :state="!$v.data.email.$error"/>
          <b-form-invalid-feedback v-if="!$v.data.email.required">{{$t('user.required-email')}}
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!$v.data.email.email">{{$t('user.required-email-check')}}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
    <div class="d-flex justify-content-between align-items-center">
      <b-button @click="goLogin" variant="outline-primary" size="" class="btn-shadow">{{ $t('button.back')}}
      </b-button>
      <b-button @click="find" variant="primary" size="lg" :disabled="processing" :class="{'btn-multiple-state btn-shadow': true,
                'show-spinner': processing,
                'show-success': !processing && loginError===false,
                'show-fail': !processing && loginError }">
                        <span class="spinner d-inline-block">
                            <span class="bounce1"></span>
                            <span class="bounce2"></span>
                            <span class="bounce3"></span>
                        </span>
        <span class="icon success">
                            <i class="simple-icon-check"></i>
                        </span>
        <span class="icon fail">
                            <i class="simple-icon-exclamation"></i>
                        </span>
        <span class="label">{{ isFindId ? $t('user.forgot-id') : $t('user.reset-password') }}</span>
      </b-button>
    </div>
  </b-form>
</template>
<script>

  import {
    validationMixin
  } from "vuelidate";
  import {mapGetters} from "vuex";

  const {
    required,
    maxLength,
    minLength,
    numeric,
    email
  } = require("vuelidate/lib/validators");

  export default {
    components: {},
    mixins: [validationMixin],
    validations: {
      data: {
        username: {
          required
        },
        email: {
          required,
          email
        },
        fullName: {
          required,
        }
      }
    },
    props: ['data', '_mode'],
    mounted() {
      if (this._mode === 'id') {
        this.isFindId = true
      }
    },
    data() {
      return {
        isFindId: false
      }
    },
    computed: {
      ...mapGetters(["processing", "loginError"])
    },
    methods: {
      goLogin(){
        this.$router.push(`/${this.$route.params.sitename}/user/login`)
      },
      find() {
        this.$v.$touch()
        if( this.isFindId ) {
          if (this.$v.data.fullName.$invalid === false && this.$v.data.email.$invalid === false ) {
            this.$emit('findFunction')
          }
        } else {
          if (this.$v.data.username.$invalid === false && this.$v.data.email.$invalid === false ) {
            this.$emit('findFunction')
          }
        }
      }
    }
    , watch: {}
  }
</script>
